import { UUID_REGEX } from 'components/route/regex-patterns'
import { randomNumberFromInterval } from 'util/number'

const UUID_PATTERN = new RegExp(`^${UUID_REGEX}$`, 'i')
const NUMERO_PATTERN = /^\d+$/
const JWT_PATTERN = /^[\w-]+\.[\w-]+\.[\w-]+$/

const SAMPLING_KEY = 'ANALYTICS_AMOSTRAGEM'

interface AmostragemArmazenada {
  amostrado: boolean
  sampleRate: number
}

/**
 * Troca por ":id" os trechos da rota que são identificadores (numéricos ou UUID) e por
 * ":token" os que são JWT. As URLs do PEC carregam id de cidadão, de atendimento e de
 * lotação, além do token de redefinição de senha. Sem essa normalização o Umami receberia
 * dado sensível e uma cardinalidade de páginas alta demais para ser analisada.
 */
export function normalizarRota(pathname: string): string {
  const rota = pathname.split('/').map(normalizarTrecho).join('/')

  return rota || '/'
}

function normalizarTrecho(trecho: string): string {
  if (JWT_PATTERN.test(trecho)) return ':token'
  return isIdentificador(trecho) ? ':id' : trecho
}

function isIdentificador(trecho: string): boolean {
  return NUMERO_PATTERN.test(trecho) || UUID_PATTERN.test(trecho)
}

export function isNavegadorAmostrado(sampleRate: number): boolean {
  if (sampleRate >= 1) return true

  const armazenado = lerAmostragem()
  if (armazenado?.sampleRate === sampleRate) return armazenado.amostrado

  const amostrado = randomNumberFromInterval() < sampleRate
  window.localStorage.setItem(SAMPLING_KEY, JSON.stringify({ amostrado, sampleRate }))
  return amostrado
}

function lerAmostragem(): AmostragemArmazenada | null {
  try {
    return JSON.parse(window.localStorage.getItem(SAMPLING_KEY) ?? '')
  } catch {
    return null
  }
}
